import type React from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select";

const ContactDetailPage: React.FC = () => {
	const { contactId } = useParams<{ contactId: string }>();
	const [response, setResponse] = useState("");
	const [status, setStatus] = useState<string>("未対応");

	// 仮のデータ（実際はAPIから取得）
	const contact = {
		id: contactId,
		name: "山田太郎",
		email: "yamada@example.com",
		category: "一般的な問い合わせ",
		subject: "もくもく会について",
		message: "次回のもくもく会の参加方法について教えてください。",
		status: "未対応",
		createdAt: "2024-03-20T10:00:00",
	};

	const handleSubmit = () => {
		// APIを呼び出して返信を送信
		console.log("返信を送信:", { contactId, response, status });
	};

	return (
		<div className="space-y-6">
			<div className="flex justify-between items-center">
				<h1 className="text-3xl font-bold">お問い合わせ詳細</h1>
				<Button variant="outline" onClick={() => window.history.back()}>
					戻る
				</Button>
			</div>

			<div className="grid gap-6 md:grid-cols-2">
				<Card>
					<CardHeader>
						<CardTitle>問い合わせ内容</CardTitle>
						<CardDescription>
							受付日時: {new Date(contact.createdAt).toLocaleString()}
						</CardDescription>
					</CardHeader>
					<CardContent className="space-y-4">
						<div>
							<Label htmlFor="name">お名前</Label>
							<p id="name" className="mt-1">
								{contact.name}
							</p>
						</div>
						<div>
							<Label htmlFor="email">メールアドレス</Label>
							<p id="email" className="mt-1">
								{contact.email}
							</p>
						</div>
						<div>
							<Label htmlFor="category">カテゴリ</Label>
							<p id="category" className="mt-1">
								{contact.category}
							</p>
						</div>
						<div>
							<Label htmlFor="subject">件名</Label>
							<p id="subject" className="mt-1">
								{contact.subject}
							</p>
						</div>
						<div>
							<Label htmlFor="message">メッセージ</Label>
							<p id="message" className="mt-1 whitespace-pre-wrap">
								{contact.message}
							</p>
						</div>
					</CardContent>
				</Card>

				<Card>
					<CardHeader>
						<CardTitle>対応内容</CardTitle>
					</CardHeader>
					<CardContent className="space-y-4">
						<div className="space-y-2">
							<Label htmlFor="status">ステータス</Label>
							<Select value={status} onValueChange={setStatus}>
								<SelectTrigger id="status">
									<SelectValue placeholder="ステータスを選択" />
								</SelectTrigger>
								<SelectContent>
									<SelectItem value="未対応">未対応</SelectItem>
									<SelectItem value="対応中">対応中</SelectItem>
									<SelectItem value="解決済み">解決済み</SelectItem>
									<SelectItem value="保留中">保留中</SelectItem>
								</SelectContent>
							</Select>
						</div>
						<div className="space-y-2">
							<Label htmlFor="response">返信内容</Label>
							<Textarea
								id="response"
								value={response}
								onChange={(e) => setResponse(e.target.value)}
								placeholder="返信内容を入力してください"
								rows={10}
							/>
						</div>
						<Button onClick={handleSubmit} className="w-full">
							返信を送信
						</Button>
					</CardContent>
				</Card>
			</div>
		</div>
	);
};

export default ContactDetailPage;
